<template>
  <div class="ui form">
    <div class="field">
      <label v-if="!options.hideLabel" >{{label}}</label>
    </div>
    <semui-dropdown :value="getValue" @input="setValue($event)" :options="currentCategory?dropDownOptions[currentCategory.hyperschema.$id]:[]"
                    :searchStr="currentCategory?currentCategory.search:''" @search-change="currentCategory.search=$event;loadOptions()"
                    :categoryOptions="categoryOptions.length>1?categoryOptions:undefined" @change-category="handleChangeCategory"
                    @trigger-open="$event&&categoryOptions.length==1?loadOptions():null;" :multipleSelect="multipleSelect"></semui-dropdown>
  </div>
</template>

<script>
    import SemuiDropdown from "@/components/semui-dropdown/semui-dropdown";
    import {searchEntities,getHyperSchemasByIDs} from "@/utils/jsonSchemeUtils";
    import singleControlMixin from './singleControlMixin'
    import {isArray} from 'lodash'
    import Vue from 'vue'

    export default {
      name:"dropdown-remote-control",
      mixins: [singleControlMixin],
      components: {SemuiDropdown},
      props:{hyperSchema:[Object,String,Array],multipleSelect:[Boolean]},
      data () {
        return {
          dropDownOptions:{},
          categoryOptions:[],
          currentCategory:null
        };
      },
      created(){
        getHyperSchemasByIDs(this.hyperSchema).then(hses=>{
          this.categoryOptions=hses.map(hs=>{return {"label":hs.title,"hyperschema":hs,"search":""}})
          if (this.categoryOptions.length==1) this.currentCategory=this.categoryOptions[0];
        })
      },

      methods:{
        handleChangeCategory(newCategory){
          this.currentCategory=newCategory
          if (!this.dropDownOptions[this.currentCategory.hyperschema.$id]) this.loadOptions();
        },
        loadOptions(){
          const currentCategory = this.currentCategory;//Делаем локальную копию, т.к. она может поменяться когда придет ответ от сервера
          Vue.set(this.dropDownOptions,currentCategory.hyperschema.$id,[])
          searchEntities(currentCategory.hyperschema,"label:"+this.currentCategory.search).then((response) => {
            Vue.set(this.dropDownOptions,currentCategory.hyperschema.$id,response.content || response)
          })
        }
      }

    }
</script>

<style scoped>

</style>
